import { v4 as uuidv4 } from 'uuid';
import {
  Exclude,
  Expose,
  Transform,
  Type,
} from 'class-transformer';

import moment from 'moment';
import Job from './Job';
import Employee from './Employee';

@Exclude()
class EmployeeHasJob {
  static entity = 'employeeHasJobs';
  static primaryKey = 'uuid';

  @Expose({ groups: ['all'] })
  new: boolean = true;

  @Expose({ groups: ['all'] })
  edit: boolean = false;

  @Expose({ notEmptyOnly: true })
  id: number | null = null;

  @Expose()
  tag: string | null = null;

  @Expose()
  uuid: string = uuidv4();

  @Expose({ groups: ['all'] })
  employeeUuid: string = '';

  @Expose({ groups: ['all'] })
  jobUuid: string = '';

  @Expose()
  @Type(() => Date)
  @Transform(value => moment(value).format('YYYY-MM-DDTHH:mm:ss'), { toPlainOnly: true })
  beginDate: Date = new Date();

  @Expose()
  @Type(() => Date)
  @Transform(value => (value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : null), { toPlainOnly: true })
  endDate: Date | null = null;

  @Expose({ name: 'job', toPlainOnly: true })
  jobId: number | null = null;
  job: Job | null = null;

  @Expose({ name: 'employee', toPlainOnly: true })
  employeeId: number | null = null;
  employee: Employee | null = null;

  get isSave(): boolean {
    return this.id !== null;
  }

  get isActive(): boolean {
    return this.endDate === null || this.endDate > TODAY;
  }
}

export default EmployeeHasJob;
